var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningAmberOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WarningAmberOutlined"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 5.40837L16.2747 16.25H3.72467L9.99967 5.40837ZM9.99967 2.08337L0.833008 17.9167H19.1663L9.99967 2.08337Z",
    fill: "#7D1212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.833 13.75H9.16634V15.4167H10.833V13.75Z",
    fill: "#7D1212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.833 8.75004H9.16634V12.9167H10.833V8.75004Z",
    fill: "#7D1212"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAmberOutlined);
export default __webpack_public_path__ + "static/media/WarningAmberOutlined.14dda35104e56f1b53b1b1df2b49e765.svg";
export { ForwardRef as ReactComponent };